import React from 'react';
import { connect } from 'react-redux';
import { getTheme } from 'selectors';

const FullPageLoader = (props) => {
  const { theme } = props;

  return (
    <div className={`preload loading`} style={{ background: theme === 'dark' ? 'black' : '' }}>
      <ul className="loading-dots">
        <li />
        <li />
        <li />
      </ul>
    </div>
  );
};

function mapStateToProps(state) {
  const { theme } = getTheme(state);
  return {
    theme
  };
}
export default connect(mapStateToProps, null)(FullPageLoader);
